export { default } from './input';
